import { styled } from '@mui/material';
import { m } from 'framer-motion';
function getModalHeight(size) {
    const { height, width } = size;
    if (width <= 320 || height <= 540) {
        return '95%';
    }
    if (width > 320 && width <= 375) {
        return '75%';
    }
    if (height <= 600) {
        return '90%';
    }
    if (height <= 800) {
        return '80%';
    }
    if (height <= 830) {
        return '75%';
    }
    return '65%';
}
export const SwipableModal = styled(m.div)(({ size }) => ({
    position: 'fixed',
    width: '100%',
    height: getModalHeight(size),
    left: 0,
    right: 0,
    bottom: -8,
    margin: '0 auto',
    zIndex: 301,
    borderRadius: 10,
    //VERY IMPORTANT FOR TOUCH INTERACTION
    touchAction: 'none',
}));
